import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Capacitor } from '@capacitor/core';

/* Font Awesom */
import "../node_modules/@fortawesome/fontawesome-free/css/all.css"

/* Bootstrap */
import "../node_modules/bootstrap/dist/css/bootstrap.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"

/* sash*/
import "../node_modules/@popperjs/core/dist/cjs/popper"
import "../node_modules/perfect-scrollbar/dist/perfect-scrollbar.min"
import "../node_modules/jquery-circle-progress/dist/circle-progress.min"
import "../node_modules/jquery-sparkline/jquery.sparkline"

import "../node_modules/itd-common/assets/css/icons.css"
import "../node_modules/itd-common/assets/css/style.css"
import "../node_modules/itd-common/assets/css/dark-style.css"
import "../node_modules/itd-common/assets/css/transparent-style.css"
import "../node_modules/itd-common/assets/css/skin-modes.css"
import "../node_modules/itd-common/assets/colors/color1.css"
import {BrowserRouter, HashRouter} from "react-router-dom";
import {LoadScript} from "@react-google-maps/api";
import TagManager from 'react-gtm-module'


TagManager.initialize({ gtmId: "GTM-TSC3Z929" })

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const libraries:("places" | "drawing" | "geometry" | "localContext" | "visualization")[]=["places","drawing"];
const onLoadMap=function() {
}

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? "";

if(!Capacitor.isNativePlatform()){
    root.render(
          <LoadScript
              googleMapsApiKey={googleMapsApiKey}
              onLoad={onLoadMap}
              libraries={libraries}
          >
            <BrowserRouter>
                  <App />
            </BrowserRouter>

          </LoadScript>
    );
}else{
    //se dehabilita captcha
    const expirationTime = Date.now() + 900 * 60 * 1000;
    sessionStorage.setItem('captchaVerified', 'true');
    sessionStorage.setItem('captchaExpiration', expirationTime+"");
    root.render(<React.StrictMode>
        <BrowserRouter>
        <App />
        </BrowserRouter>
</React.StrictMode>)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals



reportWebVitals();

